import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedMaterialModule } from 'app/shared/shared-material.module';

import { BookrawSharedModule } from 'bookraw/shared/shared.module';
import { FileUploadModule } from 'ng2-file-upload';
import { NgxMatDatetimePickerModule, NgxMatTimepickerModule } from '@angular-material-components/datetime-picker';
import { NgxMatMomentModule } from '@angular-material-components/moment-adapter';
import { FlexLayoutModule } from '@angular/flex-layout';
import { QuillModule } from 'ngx-quill';

import { ExtInputComponent } from 'bookraw/shared/components/form-input/ext-input.component';
import { ExtTextareaComponent } from 'bookraw/shared/components/form-input/ext-textarea.component';
import { ExtSelectComponent } from 'bookraw/shared/components/form-input/ext-select.component';
import { TagInputComponent } from 'bookraw/shared/components/form-input/tag-input/tag-input.component';
import { ExtDatepickerComponent } from 'bookraw/shared/components/form-input/ext-date-picker.component';
import { FileUploaderComponent } from 'bookraw/shared/components/form-input/file-uploader/file-uploader.component';
import { ExtPageLimitComponent } from 'bookraw/shared/components/form-input/ext-page-limit.component';

const components = [
  ExtInputComponent,
  ExtTextareaComponent,
  ExtSelectComponent,
  TagInputComponent,
  ExtDatepickerComponent,
  FileUploaderComponent,
  ExtPageLimitComponent
];

@NgModule({
  declarations: components,
  imports: [
    CommonModule,
    SharedMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    FileUploadModule,
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    NgxMatMomentModule,
    FlexLayoutModule,
    QuillModule
  ],
  exports: components
})
export class FormInputModule { }
